import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { PageHero, Section, Btn, ArrowLink } from "@/components/kit";
import { Reveal } from "@/lib/anim";
import { CASE_CARDS } from "@/lib/content";

const DISCLOSURE = "These engagements were carried out as an employee of the businesses described, not as Prox client work. Prox is a new practice, and client case studies will be added as engagements complete.";

export default function CaseStudies() {
  return (
    <>
      <Seo title="Case Studies — Cost, Margin & Category Results" canonical="/case-studies" description="Commercial results from thirteen years on the buying side: product cost reduction, gross margin improvement, category launches and inventory turnaround for fashion brands." keywords="fashion sourcing case study, gross margin improvement, product cost reduction, category rebuild, range planning results" />
      <PageHero
        eyebrow="Case studies"
        crumbs={[{ label: "Home", to: "/" }, { label: "Case studies" }]}
        title="What the numbers did, and how they moved."
        lead="Four results from the buying side, with the mechanism behind each one. Read them for the method, not the logos."
      >
        <p className="t-sm text-[var(--muted)] mt-8 measure border-l border-[var(--stone)] pl-5">{DISCLOSURE}</p>
      </PageHero>
      <Section bg="bone">
        <div className="grid md:grid-cols-2 gap-6">
          {CASE_CARDS.map((c, i) => (
            <Reveal i={i % 2} key={c.slug}>
              <Link to={`/case-studies/${c.slug}`} className="card block h-full p-8 md:p-10" data-testid={`case-card-${c.slug}`}>
                <span className="eyebrow">{c.label}</span>
                <div className="t-stat mt-5" style={{ fontSize: "clamp(40px,4vw,56px)" }}>{c.n}</div>
                <p className="t-body text-[var(--muted)] mt-4">{c.r}</p>
                <span className="lnk mt-7 inline-flex">Read the case<span className="arrow-anim">→</span></span>
              </Link>
            </Reveal>
          ))}
        </div>
      </Section>
      <Section bg="charcoal" dark className="py-20 md:py-24">
        <div className="max-w-3xl">
          <h2 className="t-display2">Want this on your numbers?</h2>
          <p className="t-lead mt-6 text-[var(--stone)]">Start with the free fit call and we will find the one change worth making first.</p>
          <Btn to="/book" variant="clay" className="mt-9">Book the fit call</Btn>
        </div>
      </Section>
    </>
  );
}
